module.exports = __webpack_public_path__ + "img/fontItalic.5797debc.svg";